import { useMemo } from 'react';
import { MainSource } from '../../../constants/Source';
import { bi } from '../../../services/loggers/bi';
import { unsplashLinkClick } from '@wix/bi-logger-media-data/v2';

export const useTrackUnsplashClick = () =>
  useMemo(
    () => ({
      trackUnsplashLinkClickClicked: (target, clickOrigin) =>
        bi.logger().report(unsplashLinkClick({ tabName: MainSource.Unsplash, target, clickOrigin })),
    }),
    [],
  );
